/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

addEventListener('DOMContentLoaded', function() {
  setTimeout(() => { 
    const $ = window.jQuery;
  
    $(document).ready(() => {
      const fieldMap = {
        "businessName": "options_1009_text",
        "premisesName": "options_1010_text",
        "postcode": "options_1011_text",
        "phoneNumber": "options_1012_text"
      }
  
      $('#options_1002_2').change(() => {
        if (sessionStorage.getItem('address')) {
          try {
            const addressData = JSON.parse(sessionStorage.getItem('address'));
            Object.keys(fieldMap).forEach((key) => {
              $(`#${fieldMap[key]}`).val(addressData[key]);
            });
          } catch (e) {
  
            console.log(e);
            // Something went wrong.
  
          }
        }
  
        Object.keys(fieldMap).forEach((key) => {
          $(`#${fieldMap[key]}`).focus(storeData).blur(storeData);
        });
      });
  
      function storeData() {
        let addressData = {
  
        };
        Object.keys(fieldMap).forEach((key) => {
          addressData[key] = $(`#${fieldMap[key]}`).val();
        });
  
        sessionStorage.setItem('address', JSON.stringify(addressData));
  
        console.log(addressData);
      }
    });
  }, 1500);
  
});
